const BaseView = require('components-framework/view/base.view');
const withRenderedMain = require('components-framework/view/with_rendered_main');
const UIStrategy = require('../ui_strategies/ui_strategy.factory');
const trackingUtils = require('../tracking/utils').default;

const DEFAULT_BRAND = 'ED';
const BAGGAGE_ALLOWANCE_INFO_DEFAULT_URL = {
    ED: 'https://www.edreams.com/customer-service/#/baggage/baggage-allowance/hand-baggage-allowance',
    OP: 'https://www.opodo.com/customer-service/#/baggage/baggage-allowance/hand-baggage-allowance',
    TL: 'https://www.travellink.com/customer-service/#/baggage/baggage-allowance/hand-baggage-allowance',
    GV: 'https://www.govoyages.com/service-client/#/bagages/franchise-bagages/bagages-cabine-autorises',
};


export default withRenderedMain(BaseView.extend({
    uiStrategyConst: {},
    uiStrategy: null,

    initialize(options = {}) {
        const props = options.props || {};
        this.updateProduct = props.updateProduct;
        this.updateChildContainerData = props.updateChildContainerData;
        this.widgetPosition = options.widgetPosition;
        this.bookingInfo = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo')) || {};
        this.uiStrategy = this.getUIStrategy();
        this.updateProduct(this.uiStrategy.getData());
    },

    getUIStrategy() {
        return UIStrategy.factory(this.bookingInfo, this, this.templates, this.keys, this.uiStrategyConst);
    },

    onClickProductInfo() {
        const brand = Odigeo._.get(this.bookingInfo, 'bookingBasicInfo.website.brand', DEFAULT_BRAND);
        const link = this.keys.allowanceInfoLink || BAGGAGE_ALLOWANCE_INFO_DEFAULT_URL[brand];
        window.open(decodeURIComponent(link));
    },

    getTrackingData(event) {
        return trackingUtils.getTrackingData.call(this, event);
    },
}));
